export default __webpack_public_path__ + "static/media/9.809e8b85.jpg";